import { DescriptionContainer } from '../_components/DescriptionContainer';

import { getDescriptionParts } from '../utils';
import { Typography } from '@cast/design-system';

type Props = {
  description?: string | null;
};

export const FormattedDescription = ({ description }: Props) => {
  const [beforeDescriptionPart, emailPart, afterDescriptionPart] =
    getDescriptionParts(description);

  if (!description) {
    return null;
  }

  if (!emailPart) {
    return <DescriptionContainer>{description}</DescriptionContainer>;
  }

  return (
    <DescriptionContainer>
      {beforeDescriptionPart}
      <Typography
        component="em"
        sx={{ textDecoration: 'underline', fontStyle: 'normal' }}
      >
        {emailPart}
      </Typography>
      {afterDescriptionPart}
    </DescriptionContainer>
  );
};
